import Blue from "~/core";
import _validate from "~/plugins";

new Blue({
	name: 'Form Validate',
	selector: ".form--validate",
	setup(form) {
		var formid = $('form').attr('id');
		if(formid == 'healthcare'){
			$('select').on('change', function() {
				switch (this.value) {
					case "Product":
						$("#nameofVitalantStaffdisplay").css({ display: "block" });
						$("#patientImpactdisplay").css({ display: "block" });
						$("#issuedisplay").css({ display: "block" });
						$("#complimentdisplay").css({ display: "none" });
						$("#patientImpactDetailDisplay").css({ display: "none" });
					  break;
					  case "Portal":
						$("#nameofVitalantStaffdisplay").css({ display: "block" });
						$("#patientImpactdisplay").css({ display: "block" });
						$("#issuedisplay").css({ display: "block" });
						$("#complimentdisplay").css({ display: "none" });
						$("#patientImpactDetailDisplay").css({ display: "none" });
					  break;
					case "Service":
						$("#nameofVitalantStaffdisplay").css({ display: "block" });
						$("#patientImpactdisplay").css({ display: "block" });
						$("#issuedisplay").css({ display: "block" });
						$("#patientImpactDetailDisplay").css({ display: "none" });
						$("#complimentdisplay").css({ display: "none" });
					  break;
					case "Complaint":
						$("#nameofVitalantStaffdisplay").css({ display: "block" });
						$("#patientImpactdisplay").css({ display: "block" });
						$("#issuedisplay").css({ display: "block" });
						$("#patientImpactDetailDisplay").css({ display: "none" });
						$("#complimentdisplay").css({ display: "none" });
					  break;
					  case "Billing_Sales":
						$("#nameofVitalantStaffdisplay").css({ display: "block" });
						$("#patientImpactdisplay").css({ display: "block" });
						$("#issuedisplay").css({ display: "block" });
						$("#complimentdisplay").css({ display: "none" });
						$("#patientImpactDetailDisplay").css({ display: "none" });
					  break;
					case "Compliment":
						$("#nameofVitalantStaffdisplay").css({ display: "block" });
						$("#patientImpactdisplay").css({ display: "block" });
						$("#complimentdisplay").css({ display: "block" });
						$("#issuedisplay").css({ display: "none" });
						$("#patientImpactDetailDisplay").css({ display: "none" });
					  break;
					case "Other" :
						$("#nameofVitalantStaffdisplay").css({ display: "block" });
						$("#patientImpactdisplay").css({ display: "block" });
						$("#issuedisplay").css({ display: "block" });
						$("#patientImpactDetailDisplay").css({ display: "none" });
						$("#complimentdisplay").css({ display: "none" });
					  break;
				  }
			  });
			  $('input[type="radio"]').on('click change', function(e) {
				
				var radioValue = $("input[name='patientImpact']:checked").val();
				
				switch (radioValue) {
					case "Yes":
						$("#patientImpactDetaildisplay").css({ display: "block" });
						break;
					case "No":
						console.log(radioValue);
						$("#patientImpactDetaildisplay").css({ display: "none" });
						break;	
				
				}
			});

			
		}
		
		this.$validate(form);

   }
}); 